import { useMemo } from "react";
import useGlobalContext from "./use-global-context";

type Authorization = {
    name: string;
    is_active: boolean;
}

/**
 * Hook to get the authorizations of the current user
 * @param authorizationNames - The names of the authorizations to get
 * @returns An object with the authorizations of the current user
 * @example
 * const {BYBCAT_ACCESS, FUTURE_THING} = useAuthorizations([AccountAuthorizations.BYBCAT_ACCESS, "FUTURE_THING"]);
 */
function useAuthorizations(authorizationNames: string[] = []) : {
    [key: string]: boolean
} {
    const {globalState} = useGlobalContext();
    
    const result = useMemo(() => {
        const authResults: { [key: string]: boolean } = {};
        
        authorizationNames.forEach(authName => {
            const auth = globalState.account?.authorizations?.find((a: Authorization) => a.name === authName);
            authResults[authName] = auth?.is_active || false;
        });

        return authResults;
    }, [globalState.account?.authorizations, authorizationNames]);

    return result;
}

export default useAuthorizations;
